import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBank2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBank2"><Path fillRule="evenodd" clipRule="evenodd" d="M21 19.5H22V21H2V19.5H3V11H21V19.5ZM8 19.5H9.5V13H8V19.5ZM14.5 19.5H16V13H14.5V19.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 6.35059V9.50098H2V6.35059L12 1.90527L22 6.35059ZM12 5.50098C11.4477 5.50098 11 5.94869 11 6.50098C11.0005 7.05281 11.448 7.50098 12 7.50098C12.552 7.50098 12.9995 7.05281 13 6.50098C13 5.94869 12.5523 5.50098 12 5.50098Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBank2;
